"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAddresses = exports.getAddresses = function getAddresses(addressBook) {
  return function () {
    return addressBook ? addressBook.addresses : [];
  };
};

var getSelectedAddressId = exports.getSelectedAddressId = function getSelectedAddressId(addressBook) {
  return function (addressType) {
    var selectedAddress = addressBook.selectedAddresses.find(function (sa) {
      return sa.type === addressType;
    });
    return selectedAddress ? selectedAddress.id : null;
  };
};

var isAddressBookAvailable = exports.isAddressBookAvailable = function isAddressBookAvailable(user) {
  return function () {
    return !!user && !!user.santaMariaUserId;
  };
};

var makeAddressBook = exports.makeAddressBook = function makeAddressBook(_ref) {
  var addressBook = _ref.addressBook;
  return addressBook;
};
var makeUser = exports.makeUser = function makeUser(_ref2) {
  var user = _ref2.user;
  return user;
};


//////////////////
// WEBPACK FOOTER
// ./shared/higherOrder/addressBook/stateReaders.js
// module id = 2523
// module chunks = 0